import React, { useState } from 'react';
import './gallery.css'; // You'll need to create this CSS file

const Gallery = () => {
  // Sample image URLs (replace these with your actual image paths)
  const images = [
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg',
    'https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg'
    
  ];
 
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleImages = 5; // Number of images to show at once

  const handlePrev = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? images.length - visibleImages : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) => 
      prev >= images.length - visibleImages ? 0 : prev + 1
    );
  };

  return (
    <div className="gallery-container">
      <button className="nav-arrow left" onClick={handlePrev}>&lt;</button>
      
      <div className="gallery-wrapper">
        <div 
          className="gallery-inner" 
          style={{ transform: `translateX(-${currentIndex * (100 / visibleImages)}%)` }}
        >
          {images.map((src, index) => (
            <div key={index} className="gallery-item">
              <img src={src} alt={`Gallery item ${index + 1}`} />
              {index === 2 && (
                <span className="plus-icon">+</span> // Plus icon for the center image
              )}
            </div>
          ))}
        </div>
      </div>
      
      <button className="nav-arrow right" onClick={handleNext}>&gt;</button>
    </div>
  );
};

export default Gallery;